import {delegateEvent, showDesktopLanguages, showMobileLanguages} from "./common"
import "../scss/the-watchtower.scss"
import {initSearch} from "../components/the-watchtower/init-search";

const {filterTopic} = initSearch()

delegateEvent("change", ".search-input", (e) => {
    const {target: {value}} = e
    e.target.value = ""
    if (!value) {
        return
    }
    if (!filterTopic.hasKeyword(value)) {
        filterTopic.addKeyword(value)
    }
})

delegateEvent("click", ".f-button.btn-ghost.keyword", ({target: {classList, innerHTML}}) => {
    if (classList.contains("selected")) {
        filterTopic.removeKeyword(innerHTML)
    } else {
        filterTopic.addKeyword(innerHTML)
    }
})

delegateEvent("click", ".f-button.btn-ghost", (e) => {
    const {target: {classList, innerText}, preventDefault} = e
    e.preventDefault()
    classList.toggle("selected")
    if (classList.contains("keyword")) {
        return false
    }
    if (classList.contains("selected")) {
        filterTopic.addYear(innerText)
    } else {
        filterTopic.removeYear(innerText)
    }
})

delegateEvent("click", ".js-language-menu", showDesktopLanguages, showMobileLanguages)
